import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import KeywordTopics from '../components/KeywordTopics.jsx';
import { getRouteMetadata } from '../utils/seoMetadata.js';
import './Blog.css';

function SEOLandingPage() {
  const location = useLocation();
  const metadata = getRouteMetadata(location.pathname);
  const slug = location.pathname.split('/').filter(Boolean).at(-1);

  return (
    <main className="blog-page">
      <section className="blog-hero">
        <div className="container blog-hero-inner">
          <p className="blog-eyebrow">Clientalio Guide</p>
          <h1>{metadata.h1 || metadata.ogTitle}</h1>
          <p>{metadata.description}</p>
        </div>
      </section>
      <KeywordTopics slug={slug} />
      <section className="blog-content">
        <div className="container blog-content-inner">
          <p className="blog-status">This Clientalio SEO guide is being expanded. You can still explore the product pages below.</p>
          <div className="blog-article-tags">
            <Link to="/features">Features</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/blog">Blog</Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default SEOLandingPage;